import InvoiceForm from './InvoiceForm';

const AddInvoice = () => {
    return <InvoiceForm isUpdate={false} />;
};

export default AddInvoice;
